import api from "./baseApi.js";

export default {
    GetAccessDeniedPage() {
        return api.get("AccessDeniedPage/GetAccessDeniedPage/");
    }
}